module.exports = __webpack_public_path__ + "14de84db3183d5c5b6eaaecb6a0a769b.svg";